import { render, staticRenderFns } from "./CardEditView.vue?vue&type=template&id=2d68c500&scoped=true&"
import script from "./CardEditView.vue?vue&type=script&lang=ts&"
export * from "./CardEditView.vue?vue&type=script&lang=ts&"
import style0 from "./CardEditView.vue?vue&type=style&index=0&id=2d68c500&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68c500",
  null
  
)

export default component.exports